import { React, useState, useRef, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import digitalAssistantsStyles from '../../DigitalAssistants.module.css';
import Dropdown from 'react-bootstrap/Dropdown';

import { Typeahead, TypeaheadMenu } from 'react-bootstrap-typeahead';
import { useAuth } from 'react-oidc-context';
import { Offcanvas } from 'react-bootstrap';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import { Button, ButtonBase } from '@mui/material';
import TransparentButton from '../../utils/TransparentButton';
import TransparentButtonDark from '../../utils/TransparentButtonDark';
import { SnackbarContext } from '../../App';

import CheckIcon from '@mui/icons-material/Check';

const accountTypes = [
  {
    code: 'xero',
    title: 'XERO',
  },
  {
    code: 'myob',
    title: 'MYOB',
  },
];

export default function AddUserModal({ addUserModalShow, closeAddUserModal, confirmAddUser, checkClientExist, users }) {
  const [
    clientABN,
    setClientABN,
  ] = useState('');
  const [
    clientName,
    setClientName,
  ] = useState('');

  const [
    contactName,
    setContactName,
  ] = useState('');

  const [
    contactEmail,
    setContactEmail,
  ] = useState('');

  const [
    agentEmails,
    setAgentEmails,
  ] = useState([]);

  const [
    isAbnValid,
    setIsAbnValid,
  ] = useState(false);

  const [
    tradingAccountName,
    setTradingAccountName,
  ] = useState('');

  const [
    tradingAccountType,
    setTradingAccountType,
  ] = useState('XERO');

  const [
    autoForwarding,
    setAutoForwarding,
  ] = useState(false);

  const [
    currentStep,
    setCurrentStep,
  ] = useState('General');

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    currentAccountingSoftware,
    setCurrentAccountingSoftware,
  ] = useState('XERO');

  const [
    selectedUsers,
    setSelectedUsers,
  ] = useState([]);

  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    adminAccountant,
    setAdminAccountant,
  ] = useState(auth.user?.profile.preferred_username);
  const abnRef = useRef(null);
  const [
    abnValidity,
    setAbnValidity,
  ] = useState(null);

  function reset() {
    setClientABN('');
    setClientName('');
    setContactName('');
    setContactEmail('');
    setTradingAccountType('XERO');
    setAutoForwarding(false);
    setSelectedUsers([]);
    setCurrentStep('General');
    setCurrentAccountingSoftware('XERO');
  }

  function onClose() {
    closeAddUserModal();
    reset();
  }

  const handleABNChange = async () => {
    const abn = abnRef.current.value;
    if (abn) {
      const isValid = await isValidABN(abn);
      setAbnValidity(isValid);
    } else {
      setAbnValidity(null);
    }
  };

  const isValidABN = async (abn) => {
    const abnPattern = /^(\d{11})$/;
    return abnPattern.test(abn);
  };

  function addUser() {
    console.log(autoForwarding);

    confirmAddUser({
      abn: clientABN.replaceAll(' ', ''),
      name: clientName,
      as_type: currentAccountingSoftware.toUpperCase(),
      contact_name: contactName,
      contact_email: contactEmail,
      auto_forwarding: autoForwarding,
      users: selectedUsers,
    });

    reset();
  }

  function abnCallback(data) {
    // console.log(data)
    return data;
  }

  async function checkABN(abn) {
    const response = await fetch(`https://abr.business.gov.au/json/AbnDetails.aspx?callback=abnCallback&abn=${abn}&guid=4323553b-7eca-4ef2-974d-97c38996e1a9`);

    const data = await response.text();

    let jsonData = eval(data);

    if (jsonData.Message.length !== 0) {
      return false;
    }

    return jsonData.EntityName;
  }

  async function abnChangeHandler(e) {
    setClientABN(e.target.value);
    if (isValidABN(e.target.value)) {
      let compName = await checkABN(e.target.value);
      if (compName) {
        setClientName(compName);
        setIsAbnValid(true);
      } else {
        setIsAbnValid(false);
      }
    } else {
      setIsAbnValid(false);
    }
  }

  function changeClientABN(e) {
    const abnValue = e.target.value;
    setClientABN(abnValue);
    handleABNChange(abnValue);
  }

  function changeClientName(e) {
    setClientName(e.target.value);
  }

  function changeAdminAccountant(e) {
    setAdminAccountant(e.target.value);
  }

  function changeTradingAccountName(e) {
    setTradingAccountName(e.target.value);
  }

  function changeTradingAccountType(e) {
    setTradingAccountType(e.target.value);
  }

  function addAgentEmailHandler(agents) {
    setAgentEmails(agents.map(email => email.label));
  }

  return (
    <>
      <Modal
        show={addUserModalShow}
        onHide={onClose}
        dialogClassName="modal-50w"
        aria-labelledby="example-custom-modal-styling-title"
      >

        <Modal.Body style={{ padding: '2vw 3vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.8)' }}>

          <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '1vw', fontWeight: '500', color: 'rgb(0, 15, 30, 0.8)' }}>Add New Client</h4>

          {/* {isLoading && <CircularProgress  style={{marginBottom: '1vw', color: 'white'}}/>} */}

          {currentStep == 'General' && (
            <div>
              <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.8)' }}>Please provide the general information below</p>
              <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
                <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw', marginLeft: '0.2vw' }}>Client ABN</p>
                <p style={{ fontSize: '0.75vw', marginLeft: '0.2vw' }}>Australian Business Number associated with the provided client name.</p>
                <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.7)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Australian Business Number" ref={abnRef} value={clientABN} onChange={abnChangeHandler} />
              </Form.Group>
              <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
                <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw', marginLeft: '0.2vw' }}>Client Name</p>
                <p style={{ fontSize: '0.75vw', marginLeft: '0.2vw' }}>Client name must be the same as in the selected accounting software.</p>
                <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.7)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Client Name" value={clientName} onChange={changeClientName} />
              </Form.Group>
              <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
                <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw', marginLeft: '0.2vw' }}>Accounting Software</p>
                <p style={{ fontSize: '0.75vw', marginLeft: '0.2vw' }}>This option allows Gayatri to download reports from the chosen accounting software and populate corresponding tabs in workpaper.</p>
                <div style={{ display: 'inline-block', backgroundColor: 'rgb(255, 255, 255, 0.6)', borderRadius: '0.6vw', padding: '0.3vw' }}>

                  {/* <div style={{pointerEvents: 'none'}}> */}
                  {[
                    'XERO',
                    'MYOB',
                    'NA',
                  ].map((option, index) => (
                    <span style={{}}>
                      <TransparentButtonDark
                        style={{ padding: '0.3vw 0.75vw', borderRadius: '0.5vw' }}
                        onClick={() => {
                          setCurrentAccountingSoftware(option);
                        }}
                        selected={currentAccountingSoftware.toLowerCase() == option.toLowerCase()}
                      >
                        {option}
                      </TransparentButtonDark>
                    </span>
                  ))}
                  {/* </div> */}

                </div>
              </Form.Group>

              <Button
                onClick={() => {
                  if (!isAbnValid) {
                    setSnackBarMessage('Client ABN not valid or not found');
                    setSnackBarShow(true);
                    return;
                  }

                  if (checkClientExist(clientABN)) {
                    setSnackBarMessage('This client has already been added to the system');
                    setSnackBarShow(true);
                    return;
                  }

                  setCurrentStep('Communication');
                }}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Next
              </Button>
            </div>
          )}

          {currentStep == 'Communication' && (
            <div>
              <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.8)' }}>Provide the communication information below</p>
              <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
                <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>
                  Contact Person Name
                  <span style={{ fontSize: '0.8vw' }}>(Optional)</span>
                </p>
                <p style={{ fontSize: '0.75vw', marginLeft: '0.2vw' }}>Contact person name to forward report to.</p>
                <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.7)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Contact Name" value={contactName} onChange={e => setContactName(e.target.value)} />
              </Form.Group>
              <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
                <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>
                  Contact Person Email
                  <span style={{ fontSize: '0.8vw' }}>(Optional)</span>
                </p>
                <p style={{ fontSize: '0.75vw', marginLeft: '0.2vw' }}>Contact person email address to forward report to.</p>
                <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.7)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Contact Email" value={contactEmail} onChange={e => setContactEmail(e.target.value)} />
              </Form.Group>
              <Form.Group style={{ marginBottom: '1.5vw', flex: 1, textAlign: 'left' }}>
                <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Auto-forwarding</p>
                <p style={{ fontSize: '0.75vw', marginLeft: '0.2vw' }}>Automatically forward report to client when there is a new report.</p>
                <div style={{ display: 'inline-block', backgroundColor: 'rgb(255, 255, 255, 0.6)', borderRadius: '0.6vw', padding: '0.3vw' }}>
                  {[
                    'YES',
                    'NO',
                  ].map((option, index) => (
                    <span style={{}}>
                      <TransparentButtonDark
                        style={{ padding: '0.3vw 0.75vw', borderRadius: '0.5vw' }}
                        onClick={() => {
                          setAutoForwarding(option.toLowerCase() == 'yes' ? true : false);
                        }}
                        selected={autoForwarding == (option.toLowerCase() == 'yes' ? true : false)}
                      >
                        {option}
                      </TransparentButtonDark>
                    </span>
                  ))}
                </div>
              </Form.Group>

              <Button
                onClick={() => {
                  if (autoForwarding && contactName.length == 0 && contactEmail.length == 0) {
                    setSnackBarMessage('Contact name and email must be provided if auto-forwarding is YES');
                    setSnackBarShow(true);
                    return;
                  }
                  setCurrentStep('Permission');
                }}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '0', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Next
              </Button>

              <Button
                onClick={() => { setCurrentStep('General'); }}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 0, 0, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundColor: 'rgb(255, 255, 255, 0.5)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Previous
              </Button>
            </div>
          )}

          {currentStep == 'Permission' && (
            <div>
              <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.8)' }}>Select all the users that will have access to this client</p>
              <div style={{ margin: '1vw 0', backgroundColor: 'rgb(255, 255, 255, 0.4)', borderRadius: '1vw', overflow: 'hidden', maxHeight: '40vh', overflowY: 'scroll' }}>

                {users.map(item => (
                  <ButtonBase
                    onClick={() => {
                      console.log('clicked');
                      if (selectedUsers.find(user => user.email == item.email)) {
                        setSelectedUsers((prevState) => {
                          console.log(prevState.filter(user => user.email != item.email));
                          return prevState.filter(user => user.email != item.email);
                        });
                      } else {
                        setSelectedUsers((prevState) => {
                          return [
                            ...prevState,
                            item,
                          ];
                        });
                      }
                    }}
                    style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', padding: '0.6vw 1.2vw', marginTop: '0', marginBottom: '0', width: '100%' }}
                  >
                    <div style={{ marginRight: '1vw' }}>
                      <img width="2vw" src={`https://ui-avatars.com/api/?name=${item.firstName}+${item.lastName}`} style={{ width: '2vw', borderRadius: '50%' }} alt="User avatar" />
                    </div>
                    <div style={{ fontWeight: '500', fontSize: '0.8vw', flex: 1 }}>
                      <p style={{ marginBottom: '0.1vw', textAlign: 'left', fontSize: '0.9vw' }}>
                        {item.firstName}
                        {' '}
                        {item.lastName}
                      </p>
                      <p style={{ margin: 0, textAlign: 'left', fontSize: '0.7vw', fontWeight: '400' }}>{item.email}</p>
                    </div>
                    <div style={{ justifySelf: 'flex-end' }}>
                      { selectedUsers.find(user => user.email == item.email) && <CheckIcon style={{ fontSize: '1vw' }} />}
                    </div>
                  </ButtonBase>
                ))}
              </div>

              <Button
                onClick={addUser}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '0', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Confirm
              </Button>

              <Button
                onClick={() => { setCurrentStep('Communication'); }}
                variant="outlined"
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 0, 0, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundColor: 'rgb(255, 255, 255, 0.5)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
              >
                Previous
              </Button>
            </div>
          )}

        </Modal.Body>
      </Modal>

    </>
  );
}
